/**
 * Risk Report.
 * @module advisor/components/reports/RiskReport
 *
 */

import React, {useState} from 'react';
import debug from 'debug';
import {connect} from 'react-redux';
import axiosInstance from '../../../shared/utils/axios';
import {Button, DescriptiveText} from '../../../shared';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import {_getUnreadReports} from '../../../shared/store';

const log = debug('circleblack:riskReport');

/**
 * Risk Report component.
 *
 * @name RiskReport
 * @requires module:shared/components/Button
 * @requires module:shared/components/SectionTitle
 *
 */

function RiskReport(props) {
  const {session, report, unreadReportsTimeoutID, unreadReports, reportPageVisitTimestamp, getUnreadReports} = props;
  const [step, setStep] = useState(1);
  const [message, setMessage] = useState('');

  let cat;
  let catID;
  let branchID;
  const parameters = [];

  const createParams = () => {
    switch (session.profile.role) {
      case 'FIRMMGR':
      case 'CPLO':
        cat = 'firm';
        catID = session.profile.firm.id;
        break;
      case 'BRANCHMGR':
        cat = 'branch';
        catID = branchID;
        break;
      case 'ADVISOR':
        cat = 'advisor';
        catID = session.profile.id;
        break;
      default:
        break;
    }
    for (let i = 0; i < report.parameters.length; i++) {
      if (report.parameters[i].name === 'catID') {
        parameters.push({
          id: report.parameters[i].id,
          value: catID,
        });
      }
      if (report.parameters[i].name === 'cat') {
        parameters.push({
          id: report.parameters[i].id,
          value: cat,
        });
      }
    }
    return parameters;
  };

  const generateReport = () => {
    (session.profile.role === 'BRANCHMGR' ? axiosInstance.get('/branches') : Promise.resolve())
      .then(function generate(res) {
        if (res !== undefined) {
          branchID = res.data[0].id; // ETODO Support selecting multiple branches for managers that manage multiple
        }
        createParams();
        return axiosInstance.post(`/reports/${props.report.name}`, {parameters})
          .then(() => {
            setMessage('Success! Your report is being generated and you will receive a notification when it is ready.');
            setStep(step + 1);

            getUnreadReports(unreadReportsTimeoutID, unreadReports, reportPageVisitTimestamp, 30000);
          });
      })
      .catch((err) => {
        setMessage('Report failed to generate ' + err.response.data.error.msg);
        setStep(step + 1);
      });
  };

  const renderStep = (steps) => {
    log('renderStep', 'step', steps);
    switch (steps) {
      case 1:
        return <div>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          <DescriptiveText>The Risk Report displays Households' Target and Actual Risk data.</DescriptiveText>
          <Button importance={'secondary'} size={'md'} label={'Generate'} disabled={false} action={generateReport}/>
        </div>;
      case 2:
        return <DescriptiveText>{message}</DescriptiveText>;
      default:
        return <div>Something went wrong</div>;
    }
  };

  // TODO Update Risk Report to use Steps Component even though there is only 1 step and a success message?
  return renderStep(step);
}

const mapStateToProps = state => ({
  session: state.session,
  unreadReportsTimeoutID: state.badges.unreadReportsTimeoutID,
  unreadReports: state.badges.unreadReports,
  reportPageVisitTimestamp: state.badges.reportPageVisitTimestamp,
});

const mapDispatchToProps = dispatch => ({
  getUnreadReports: (timeoutID, unread, timestamp, interval) => dispatch(_getUnreadReports(timeoutID, unread, timestamp, interval)),
});

RiskReport.propTypes = {
  /**
   * The Report to be generated
   */
  report: PropTypes.shape({}).isRequired,
  /**
   * Is from Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.object}).isRequired,
  /**
   * Are from badges reducer
   */
  getUnreadReports: PropTypes.func,
  unreadReportsTimeoutID: PropTypes.object,
  unreadReports: PropTypes.object,
  reportPageVisitTimestamp: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(RiskReport);

